export class User {
    name: string = '';
    role: string = '';
    department: string = '';
    id: string = '';
    azureUserName = '';
    accessFeatures: string[] = [];
    userKey: string = '';
    actsAsOtherUser: boolean = false;
    static getEmpty(): User {
        return new User();
    }
}
